// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const maractus: PokeData = {
  "id": 556,
  "name": "maractus",
  "height": 10,
  "weight": 280,
  "base_experience": 161,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [
    "pin-missile",
    "peck",
    "absorb",
    "mega-drain",
    "leech-seed",
    "growth",
    "solar-beam",
    "petal-dance",
    "cotton-spore",
    "giga-drain",
    "sweet-scent",
    "synthesis",
    "sunny-day",
    "ingrain",
    "needle-arm",
    "acupressure",
    "sucker-punch",
    "after-you",
    "cotton-guard",
    "petal-blizzard",
    "spiky-shield"
  ],
  "moves": [
    "pin-missile",
    "peck",
    "solar-beam",
    "synthesis",
    "sunny-day",
    "branch-poke",
    "overgrowth",
    "vine-whip",
    "leaf-tornado",
    "aromatherapy",
    "razor-leaf",
    "bullet-seed",
    "flower-rush"
  ],
  "evolution_chain": {
    "id": 283,
    "item": null,
    "species": [
      {
        "name": "maractus",
        "order": 557,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 120,
    "speed": 101,
    "ability_power": 179
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
